<template>
    <CustomModal
        :is-modal-visible="editVisible"
        :modal-title="`Chỉnh sửa cấu hình năm học ${selectedYearFromStore} - ${
            selectedYearFromStore + 1
        }`"
        :close-function="handleCloseModalEdit"
        :size="'md'"
        :err-modal="errModal"
    >
        <template v-slot:content>
            <div class="row">
                <div class="col-md-4">
                    <label class="label">
                        Thời gian <span class="error-label">*</span>
                    </label>
                        <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            start-placeholder="Từ ngày"
                            end-placeholder="Đến ngày"
                            size="medium"
                            format="dd/MM/yyyy"
                            @change="onChangeDateRange"
                        >
                        </el-date-picker>
                        <span
                            v-if="err_start_date || err_end_date"
                            class="text-error-select"
                        >
                            {{ err_start_date || err_end_date }}
                        </span>
                </div>
            </div>
        </template>

        <template v-slot:btn-handle>
            <CustomButton label="Cập nhật" @click="handleUpdate" />
        </template>
    </CustomModal>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'

import sendRequest from '@/services'
import Api from '@/constants/Api'
import CustomModal from '@/components/CustomModal.vue'
import { showNotication } from '@/utils/notification'
import { formatDateToDDMMYYYY, formatDateToYYYYMMDD } from '@/utils'
import { validateFields, handlerError } from '@/utils/validator'
export default {
    name: 'ModalAdd',
    data() {
        return {
            dateRange: '',
            startDate: '',
            endDate: '',

            err_start_date: '',
            err_end_date: '',

            errModal: false
        }
    },
    props: {
        editVisible: {
            type: Boolean,
            required: true
        },
        closeModalEdit: Function,
        handleSearch: Function,
        dataEdit: {
            type: Object,
            require: true
        }
    },
    components: { CustomButton, CustomModal },
    watch: {
        editVisible(newValue) {
            if (newValue === true) {
                this.bindData()
            }
        }
    },
    methods: {
        onChangeDateRange(value) {
            if (value && value.length === 2) {
                this.startDate = value[0]
                this.endDate = value[1]
                this.onChangeHandler('startDate', this.startDate)
                this.onChangeHandler('endDate', this.endDate)
            } else {
                this.startDate = ''
                this.endDate = ''
                this.err_start_date = ''
                this.err_end_date = ''
                this.errModal = false
            }
        },
        onChangeHandler(source, newValue) {
            const errorFields = {
                startDate: 'err_start_date',
                endDate: 'err_end_date'
            }

            handlerError(this, source, newValue, errorFields)

            if (source in errorFields) {
                handlerError(this, source, newValue, errorFields)

                this.errModal = !!newValue || !!this[errorFields[source]]
            } else {
                this.errModal = !!newValue
            }
        },
        bindData() {
            this.startDate = formatDateToYYYYMMDD(this.dataEdit.dauNamTuNgay)
            this.endDate = formatDateToYYYYMMDD(this.dataEdit.dauNamToiNgay)
            this.dateRange =
                this.startDate && this.endDate
                    ? [this.startDate, this.endDate]
                    : ''
            this.err_start_date = ''
            this.err_end_date = ''
        },
        handleCloseModalEdit() {
            this.closeModalEdit()
            this.bindData()
        },
        async handleUpdate() {
            // Đồng bộ từ date range (v-model) sang startDate/endDate trước khi validate
            if (this.dateRange && Array.isArray(this.dateRange) && this.dateRange.length === 2) {
                this.startDate = this.dateRange[0]
                this.endDate = this.dateRange[1]
            }
            const fieldsToValidate = [
                {
                    value: this.startDate,
                    errorField: 'err_start_date'
                },
                {
                    value: this.endDate,
                    errorField: 'err_end_date'
                }
            ]

            if (validateFields(this, fieldsToValidate)) {
                const convertStartDate = formatDateToDDMMYYYY(this.startDate)

                const convertEndDate = formatDateToDDMMYYYY(this.endDate)
                const request_data = {
                    namHoc: this.selectedYearFromStore,

                    denNgay: convertEndDate,
                    idSo: this.auth_user.ma_so,
                    id: this.dataEdit.id,

                    status: null,
                    tuNgay: convertStartDate
                }
                try {
                    const response = await sendRequest(
                        Api.tiep_nhan_du_lieu_QLNT.cau_hinh_lich_dong_bo
                            .chinh_sua_ngay,
                        request_data,
                        this.request_headers
                    )
                    if (response.rc == 0) {
                        showNotication(this, 'success', 'Cập nhật thành công', {
                            customClass: 'notification-unlock'
                        })
                        this.closeModalEdit()
                        this.$emit('handleSearch')
                    } else {
                        showNotication(
                            this,
                            'warning',
                            response.message,
                            {
                                customClass: 'notification-lock'
                            }
                        )
                    }
                } catch (error) {
                    if (error.response?.data.rd) {
                        showNotication(this, 'error', error.response?.data.rd)
                    }
                }
            }
        }
    },

    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
.label {
    font-weight: 600;
}
</style>
